import * as React from "react";
import { MenuItem } from "components/bootstrap";
import useEventActionCondition, {
  isNotSystemEvent
} from "security-app/components/Investigations/plugin/useEventActionCondition";
import AddEvidenceModal from "./shared/AddEvidenceModal";
const EventInvestigationsModalInner = ({ events, fromBulk = false }, ref) => {
  const isAvailable = useEventActionCondition(events);
  if (!isAvailable) {
    return null;
  }
  const eventIds = events.filter(isNotSystemEvent).map(({ id }) => id);
  return /* @__PURE__ */ React.createElement(AddEvidenceModal, { ids: eventIds, type: "events", ref, fromBulk });
};
export const EventInvestigationsModal = React.forwardRef(EventInvestigationsModalInner);
const InvestigationsEventAction = ({
  events,
  modalRef,
  onEventCallback
}) => {
  const eventIds = events.filter(isNotSystemEvent).map(({ id }) => id);
  if (eventIds.length === 0) {
    return null;
  }
  const onSelectInvestigation = () => {
    var _a;
    if (typeof onEventCallback === "function") {
      onEventCallback();
    }
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  };
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick: onSelectInvestigation, icon: "extension" }, "Add to investigation");
};
export default InvestigationsEventAction;
